import {PreviewReferences} from "../data";

const filler = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
// export const whitePixel = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAQSURBVHgBAQUA+v8A/////wn7A/2j0UkKAAAAAElFTkSuQmCC';

/**
 * Function is waiting until reference to SVG will be updated
 * and run colorizing function
 *
 * It takes some time to update DOM and reference after selecting option
 */
export const waitForSvgAndColorize = (references: PreviewReferences, uid: string, texture: string | null = null) => {
    const isLoading = setInterval(() => {
        const image = references.current[uid];

        if (image) {
            clearInterval(isLoading);

            colorizeSvg(image, texture);
        }
    }, 0);
};

export const waitForSvgAndDecolorize = (references: PreviewReferences, uid: string) => {
    const isLoading = setInterval(() => {
        const image = references.current[uid];

        if (image) {
            clearInterval(isLoading);

            decolorizeSvg(image);
        }
    }, 0);
}


/**
 * Function append image to SVG image
 *
 * SVG contains "pattern" tag with empty source, which is related to paths using ID
 */
export const colorizeSvg = (svg: HTMLDivElement | null = null, texture: string | null = null) => {

    if (svg == null) {
        return;
    }

    const pattern = svg.querySelector('pattern');

    if (!pattern) {
        return;
    }

    const id = pattern.getAttribute('id');

    if (!id) {
        return;
    }

    const image = svg.querySelector("pattern image");
    const paths = svg.querySelectorAll(`g > path`);

    if (!image || !paths) {
        return;
    }

    image.setAttribute('href', texture || filler);

    paths.forEach((el) => {
        el.setAttribute('style', `fill: url(#${id});`);
    });
}


export const decolorizeSvg = (svg: HTMLDivElement | null = null) => {

    if (svg == null) {
        return;
    }

    const pattern = svg.querySelector('pattern');

    if (!pattern) {
        return;
    }

    const id = pattern.getAttribute('id');

    if (!id) {
        return;
    }

    const image = svg.querySelector("pattern image");
    const paths = svg.querySelectorAll(`g > path`);

    if (!image || !paths) {
        return;
    }

    image.removeAttribute('href');

    paths.forEach((el) => {
        el.removeAttribute('style');
    });
}
